import firebase from 'firebase/app';


  var firebaseConfig = {
    apiKey: "AIzaSyACKbaCGOXxvW-0BafKiTmSIAeTYPIovlI",
    authDomain: "boooyamachinery.firebaseapp.com",
    databaseURL: "https://boooyamachinery.firebaseio.com",
    projectId: "boooyamachinery",
    storageBucket: "boooyamachinery.appspot.com",
    messagingSenderId: "166200153632",
    appId: "1:166200153632:web:b80bc248172eb009b38e45",
    measurementId: "G-LMRLXWWYML"
  };

  firebase.initializeApp(firebaseConfig, "Secondary")

  export default firebase;